import axios from 'axios';

export default {

  methods: {
    getCurrentPage(slug) {
      const lang = this.$i18n.locale;
      return axios.get(`/api/pages/${slug}?lang=${lang}`);
    },
    fontHairline() {
      if (window.navigator.userAgent.includes('Macintosh')) {
        return 'font-extralight';
      }
      return 'font-light';
    },
  },

};
